import { CaseUtil } from '@vectord/utils';
import { type Node, type NodeProps } from '@xyflow/react';
import { NodeType } from 'automations/data/nodeTypes';
import { ActionTypes } from 'automations/types/automationConfig';

export function didNodeSyncToServer(node: Node | NodeProps<Node<any>>) {
  // If node.id is a valid number, then it is synced to BE
  return !Number.isNaN(Number(node.id));
}

export function generateNewNodePayload({
  nodeType = NodeType.newBlock,
  data = {},
} : {
  nodeType?: NodeType;
  data?: any;
} = {}): Node {
  return {
    id: crypto.randomUUID(),
    type: nodeType,
    position: { x: 0, y: 0 },
    data,
  };
}

// nodeSubType values whose correct display name isn't recoverable by generic title-casing
// (e.g. brand names with an internal capital, like "WebEngage"). Add future exceptions here
// instead of special-casing them at each node-title call site.
const NODE_TITLE_OVERRIDES: Partial<Record<ActionTypes, string>> = {
  [ActionTypes.sendWebengageEvent]: 'Send WebEngage Event',
};

export function getNodeDisplayTitle(nodeSubType: ActionTypes): string {
  return NODE_TITLE_OVERRIDES[nodeSubType] ?? CaseUtil.titleCase(nodeSubType);
}
